// Recorded autonomous-flight receipt bundles for the Tessera Overview record.
//
// Two REAL sealed flight records produced by scripts/generate-flight-receipts.ts
// (deterministic multi-phase gig + in-process witness), inlined at build like
// the other demos' data.ts. Both share one agent identity and are eight-action
// missions (dispatch → A-2 → A-3 → 3 captures → A-2 → recover), differing only
// in the peak altitude on the A-2 → A-3 crossing (and thus the verdict):
//   flight-conformant — peak 382 ft (within the 400 ft ceiling) -> conformant: true
//   flight-violation  — peak 403 ft (3 ft over the ceiling)      -> conformant: false
import flightConformant from "../../../demo-artifacts-flight/receipts/flight-conformant/bundle.json";
import flightViolation from "../../../demo-artifacts-flight/receipts/flight-violation/bundle.json";

export type Bundle = Record<string, string>;

// Keyed by the bundleId each flight scenario references.
export const FLIGHT_BUNDLES: Record<string, Bundle> = {
  "flight-conformant": flightConformant as Bundle,
  "flight-violation": flightViolation as Bundle
};
